export const REGEX_DOMAIN =
  "^[a-zA-Z0-9][a-zA-Z0-9.-]{1,61}[a-zA-Z0-9]\\.[a-zA-Z]{2,}$";

export const NUMBER_PER_PAGE = 10;
export const MAX_NAME_LENGTH = 255;
